import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setDemographic } from '../../store/actions';

import MenuCloseButton from './MenuCloseButton';

import { extractLabeledColor, palette } from '../../utils/colors';
import { esriDemographicZoomLayers } from '../../config';

const radioOptions = [
  { value: 'population', label: 'Population / Sq Mi' },
  { value: 'diversity', label: 'Diversity Index' },
  { value: 'migration', label: 'Migration' },
  { value: 'households', label: 'Total Households' },
  { value: 'employed', label: 'Civilian - Employed (%)' },
  { value: 'home', label: 'Median Home Value' },
  { value: 'income', label: 'Median Household Income' },
];

const population = [
  '< 10',
  '10 - 50',
  '50 - 100',
  '100 - 500',
  '500 - 750',
  '750 - 1000',
  '> 1000',
];

const diversity = [
  '< 10',
  '10 - 20',
  '20 - 40',
  '40 - 60',
  '60 - 80',
  '80 - 90',
  '> 90',
];

const migration = [
  '< 1',
  '1 - 5',
  '5 - 10',
  '10 - 20',
  '20 - 40',
  '40 - 60',
  '> 60',
];

const households = [
  '< 50',
  '50 - 300',
  '300 - 600',
  '600 - 900',
  '900 - 1,600',
  '1,600 - 2,500',
  '> 2,500',
];

const employed = [
  '< 50',
  '50 - 55',
  '55 - 65',
  '65 - 75',
  '75 - 85',
  '85 - 95',
  '> 95',
];

const home = [
  '< 75,000',
  '75,000 - 100,000',
  '100,000 - 200,000',
  '200,000 - 300,000',
  '300,000 - 500,000',
  '500,000 - 1,000,000',
  '> 1,000,000',
];

const income = [
  '< 35,000',
  '35,000 - 50,000',
  '50,000 - 75,000',
  '75,000 - 100,000',
  '100,000 - 150,000',
  '150,000 - 200,000',
  '> 200,000',
];

export function DemographicsMenuComponent({
  demographics,
  onCloseClick,
  type,
  zoom,
  handleDemographicSubmit,
}) {
  return (
    <div className="map-toolbar__menu map-toolbar--demographics">
      <MenuCloseButton onCloseClick={onCloseClick} />
      <div className="toolbox-content filter-box">
        <form>
          <div>
            <h4>
              {
                esriDemographicZoomLayers.reduce((result, layer) => {
                  if (zoom >= layer.minZoom && zoom <= layer.maxZoom) {
                    return layer.name;
                  }

                  return result;
                }, '')
              }
            </h4>

            { radioOptions.map(layerOption => (
              <div className="map-toolbar__option" key={layerOption.label}>
                <input
                  type="radio"
                  className="radio--custom"
                  id={layerOption.value}
                  name="demographic-radio"
                  value={layerOption.value}
                  checked={demographics === layerOption.value}
                  onChange={() => handleDemographicSubmit(type, layerOption.value)}
                />
                <label htmlFor={layerOption.value}>{layerOption.label}</label>
              </div>
            ))}

          </div>
          {demographics && <div className="legend-wrap"><hr /><strong>Legend</strong></div>}
          {demographics === 'population' &&
          <div className="legend">
            {population
              .map(extractLabeledColor(palette.variant1))
              .map(([label, backgroundColor]) => (
                <div key={`population.${label}`} className="legend-value">
                  <div className="square" style={{ backgroundColor }} />{label}
                </div>
              ))
            }
          </div>
          }

          {demographics === 'diversity' &&
          <div className="legend">
            {diversity
              .map(extractLabeledColor(palette.variant2))
              .map(([label, backgroundColor]) => (
                <div key={`diversity.${label}`} className="legend-value">
                  <div className="square" style={{ backgroundColor }} />{label}
                </div>
              ))
            }
          </div>
          }

          {demographics === 'migration' &&
          <div className="legend">
            {migration
              .map(extractLabeledColor(palette.variant3))
              .map(([label, backgroundColor]) => (
                <div key={`migration.${label}`} className="legend-value">
                  <div className="square" style={{ backgroundColor }} />{label}
                </div>
              ))
            }
          </div>
          }

          {demographics === 'households' &&
          <div className="legend">
            {households
              .map(extractLabeledColor(palette.variant4))
              .map(([label, backgroundColor]) => (
                <div key={`households.${label}`} className="legend-value">
                  <div className="square" style={{ backgroundColor }} />{label}
                </div>
              ))
            }
          </div>
          }

          {demographics === 'employed' &&
          <div className="legend">
            {employed
              .map(extractLabeledColor(palette.variant5))
              .map(([label, backgroundColor]) => (
                <div key={`employed.${label}`} className="legend-value">
                  <div className="square" style={{ backgroundColor }} />{label}
                </div>
              ))
            }
          </div>
          }

          {demographics === 'home' &&
          <div className="legend">
            {home
              .map(extractLabeledColor(palette.variant6))
              .map(([label, backgroundColor]) => (
                <div key={`home.${label}`} className="legend-value">
                  <div className="square" style={{ backgroundColor }} />{label}
                </div>
              ))
            }
          </div>
          }

          {demographics === 'income' &&
          <div className="legend">
            {income
              .map(extractLabeledColor(palette.variant7))
              .map(([label, backgroundColor]) => (
                <div key={`income.${label}`} className="legend-value">
                  <div className="square" style={{ backgroundColor }} />{label}
                </div>
              ))
            }
          </div>
          }
        </form>
      </div>
    </div>
  );
}

DemographicsMenuComponent.propTypes = {
  demographics: PropTypes.string,
  onCloseClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  zoom: PropTypes.number,
  handleDemographicSubmit: PropTypes.func.isRequired,
};

export const mapDispatchToProps = dispatch => {
  return {
    handleDemographicSubmit: (type, layer) => { dispatch(setDemographic(type, layer)); },
  };
};

export default connect(null, mapDispatchToProps)(DemographicsMenuComponent);



// WEBPACK FOOTER //
// ./src/components/MapToolbar/DemographicsMenu.js